export default "__VITE_ASSET__ChOIZAOU__"